import script from "./ExpenseCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseCategories.vue?vue&type=script&setup=true&lang=js"

import "./ExpenseCategories.vue?vue&type=style&index=0&id=2dfa31bd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dfa31bd"]])

export default __exports__